// extracted by mini-css-extract-plugin
export var link = "_sx-0";